import { types } from './user-info.types';

/**
 * Normalize a raw jurisdiction/city object into the canonical Jurisdiction shape.
 * Handles both the normalizer output (center at top level) and the raw API
 * response (center nested in details).
 */
const normalizeJurisdiction = (j) => ({
    id: j.id,
    name: j.name,
    center: j.center || j.details?.center || { lat: 0, lng: 0 },
    timezone: j.timezone || null,
    region: j.region || null,
});

const initialState = {
    agencies: {
        list: [],
        agencyMap: {},
        loading: false,
        error: '',
    },
    jurisdictionNameMap: {},
    allCities: {
        list: [],
        loading: false,
        error: '',
    },
    selectedJurisdiction: null,
};

const userInfo = (state = initialState, { type, payload }) => {
    switch (type) {

    case types.GET_USER_AGENCIES_REQUEST:
        return {
            ...state,
            agencies: {
                ...state.agencies,
                loading: true,
            },
        };

    case types.GET_USER_AGENCIES_SUCCESS:
        return {
            ...state,
            agencies: {
                ...state.agencies,
                loading: false,
                list: payload.map(agency => {
                    const { cities, jurisdictions, ...rest } = agency;
                    return {
                        ...rest,
                        jurisdictions: (jurisdictions || cities || []).map(normalizeJurisdiction),
                    };
                }),
                agencyMap: payload.reduce((map, agency) => {
                    const { cities, jurisdictions, ...rest } = agency;
                    map[agency.agencies_id] = {
                        ...rest,
                        jurisdictions: (jurisdictions || cities || []).map(normalizeJurisdiction),
                    };
                    return map;
                }, {}),
            },
            jurisdictionNameMap: payload.reduce((acc, agency) => {
                (agency.jurisdictions || agency.cities || []).forEach((j) => {
                    acc[j.id] = j.name;
                });
                return acc;
            }, {}),
        };

    case types.GET_USER_AGENCIES_ERROR:
        return {
            ...state,
            agencies: {
                ...state.agencies,
                loading: false,
                error: payload,
            },
        };

    case types.CLEAR_USER_AGENCIES:
        return initialState;

    // All cities (lazy-loaded for admin Requests page)
    case types.GET_ALL_CITIES_REQUEST:
        return {
            ...state,
            allCities: { ...state.allCities, loading: true },
        };

    case types.GET_ALL_CITIES_SUCCESS:
        return {
            ...state,
            allCities: { list: payload, loading: false, error: '' },
        };

    case types.GET_ALL_CITIES_ERROR:
        return {
            ...state,
            allCities: { ...state.allCities, loading: false, error: payload },
        };

    // Selected jurisdiction (traffic viewer)
    case types.SET_SELECTED_JURISDICTION:
        return {
            ...state,
            selectedJurisdiction: payload,
        };

    default:
        return state;
    }
};

export default userInfo;
